import { createContext } from 'react';

import { useCdmSelectedLocationContext } from '../../../../providers/selected-location-provider/cdm-selected-location-context';

export interface FeatureToggleConfigContextInterface {
  useCdmSelectedLocationContext: typeof useCdmSelectedLocationContext;
}

const defaultValue: FeatureToggleConfigContextInterface = {
  useCdmSelectedLocationContext,
};

export const FeatureToggleConfigContext =
  createContext<FeatureToggleConfigContextInterface>(defaultValue);
